import React, { useEffect, useRef, useState } from 'react'

import currencies from '../../utils/currency.json'

import close from '../../images/Settings/close.svg'

export const MonetizationModal = ({isDeletePlan, isDisconnectStripe, isPriceChange, setPlanOneOpen, setMonetization, monetization, handleSaveData, setDeletePlan, setIsPriceChanged, setDisconnectStripe, isShouldCreateNew, handleAgreeBtn}) => {
    const ref = useRef();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleAgree = async () => {
        if(isLoading) {
            return;
        }

        setErrorMessage('');

        try {
            if (isDeletePlan) {
                setIsLoading(true);
                const response = await handleAgreeBtn('deletePlan');

                if( response ) {
                    setErrorMessage(response);
                }

                setIsLoading(false);
            }

            if (isDisconnectStripe) {
                setIsLoading(true);

                const response = await handleAgreeBtn('disconnectStipe');

                if( response ) {
                    setErrorMessage(response);
                }
  
                setIsLoading(false);
            }

            if (isPriceChange) {
                setIsLoading(true);
                await handleSaveData();
                setIsLoading(false);
            }
        } catch {
            setIsLoading(false);
        }
    }

    const handleCancel = () => {
        if (isDeletePlan) {
            setDeletePlan(false)
        }
        if (isDisconnectStripe) {
            setDisconnectStripe(false)
        }
        if (isPriceChange) {
            setIsPriceChanged(false)
        }
    }
    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if(isLoading) {
                return false;
            }
            if (isDeletePlan && ref.current && !ref.current.contains(e.target)) {
                setDeletePlan(false);
            }
        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isDeletePlan, isLoading]);

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (isDisconnectStripe && ref.current && !ref.current.contains(e.target)) {
                setDisconnectStripe(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isDisconnectStripe]);

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (isPriceChange && ref.current && !ref.current.contains(e.target)) {
                setIsPriceChanged(false);
            }
        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isPriceChange]);
    
    return (
        <div className="detailsPopup stripeApiModal">
            <div className="detailsPopup-inner" ref={ref}>
                <div className="popup__content">
                    <div className='popupTitle'>{isDeletePlan ? "Delete plan" : isDisconnectStripe ? "Disconnect stripe" : `Price change for ${monetization?.planNameOne || 'plan'}`}</div>
                    <div>
                        
                        <div className="step_content">
                            {
                                ((isDeletePlan || isPriceChange) && !isDisconnectStripe) &&
                                <div>
                                    {isDeletePlan && <>
                                        <p className='popupDesc'>You are about to delete a subscription plan that has active subscribers.</p>
                                        <p className='popupDesc'>Please note that all current subscribers will be notified about the cancellation of this subscription plan, will no longer be charged, and will be transferred to your free plan.</p>
                                        { monetization?.totalRemainingCredits > 0 &&
                                            <p className='popupDesc'>They will also receive a refund of {currencies[monetization?.currencyData?.currency?.toUpperCase()]?.symbol_native || '$'}{parseFloat( (monetization?.totalRemainingCredits / 100).toFixed(2) ) || 0} {monetization?.currencyData?.currency?.toUpperCase() || 'USD'} for the remaining subscription period. The refund will be sent from your Stripe account, so please ensure you have sufficient funds in your Stripe balance to process these refunds.</p>
                                        }
                                    </>}
                                    {isPriceChange && <>
                                        <p className='popupDesc'>You are about to change the price of a subscription plan that has active subscribers. Please note that only new subscribers will be subject to the new rate once the price change has taken effect. Your current subscribers will continue with the plan they initially subscribed to.</p>
                                    </>}
                                </div>
                            }
                            {
                                (isDisconnectStripe && (!isDeletePlan && !isPriceChange)) &&
                                <>
                                    <p className='popupDesc'>You are about to disconnect your Stripe account.</p>
                                    <p className='popupDesc'>
                                        Please note that by doing so, you will no longer be able to earn revenue from paid subscriptions on your personal web profile. All active subscriptions will be canceled and transferred to your free plan.
                                    </p>
                                    { monetization?.totalRemainingCredits > 0 &&
                                        <p className='popupDesc'>
                                            Also, a refund of {currencies[monetization?.currencyData?.currency?.toUpperCase()]?.symbol_native || '$'}{parseFloat( (monetization?.totalRemainingCredits / 100).toFixed(2) ) || 0} {monetization?.currencyData?.currency?.toUpperCase() || 'USD'} for the remaining subscription period will be sent to each subscriber from your Stripe account. Please ensure you have sufficient funds in your Stripe balance to process these refunds. This will immediately impact your monetization.
                                        </p>
                                    }
                                </>
                            }
                        </div>
                        <div className="step_content">
                            <p className='popupDesc'>
                            { isDeletePlan ? "Are you sure you want to proceed with deleting this subscription plan?" : isDisconnectStripe ? "Are you sure you want to proceed with disconnecting your Stripe account?" : "Are you sure you want to proceed with changing the price of this subscription plan?" }
                            </p>
                            {errorMessage && 
                                <p className="error-message" dangerouslySetInnerHTML={{ __html: errorMessage }}></p>
                            }
                        </div>
                    </div>
                    <div className='btnGroupLink btnGroupWidth'>
                        <input type="reset" value="Cancel" className="secondary-button button minwidthAuto" onClick={() => { handleCancel() }} />
                        <button className="primary-button button minwidthAuto" onClick={handleAgree}>
                            {isLoading ?
                                <div className="settingPage-loader">
                                    <div className="ring-loader"></div>
                                </div>
                                : "I agree"
                            }
                        </button>
                    </div>
                </div>
                <span className="detailsClose" onClick={() => { handleCancel() }}>
                    <img className="popupClose" src={close} alt="close" />
                </span>
            </div>
        </div>
    )
}
